module.exports = "<span *ngIf=showErrors>{{ errorLabel }}</span>";